export default "__VITE_ASSET__d7287c7e__"